import { render, staticRenderFns } from "./OrganisationCreate.vue?vue&type=template&id=771c677c&scoped=true"
import script from "./OrganisationCreate.vue?vue&type=script&lang=js"
export * from "./OrganisationCreate.vue?vue&type=script&lang=js"
import style0 from "./OrganisationCreate.vue?vue&type=style&index=0&id=771c677c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771c677c",
  null
  
)

export default component.exports